import { useRecentImages } from "../../SPA/hooks/recentimages";
import useImageUpload from "../../SPA/hooks/imageupload";
import React, { useMemo, useRef } from "react";
import Container from "@material-ui/core/Container";
import Button from "@material-ui/core/Button";
import FilterIcon from "@material-ui/icons/FilterList";
import { Trans } from "react-i18next";
import ImageIcon from "@material-ui/icons/Image";
import { Chip } from "@material-ui/core";
import UploadProgressDialog from "../../SPA/Components/UploadProgressDialog";
import CardCategories from "./CardCategories";
import { makeStyles } from "@material-ui/core/styles";
const useStyles = makeStyles((theme) => {
    return {
        typeOptions: {
            backgroundColor: "white",
            paddingTop: theme.spacing(2),
            paddingBottom: theme.spacing(2),
            boxShadow: "0px 2px 4px #00000029",
        },
        filterButtonContainer: {
            display: "flex",
            width: "100%",
            justifyContent: "space-between",
            "&.one-button": {
                justifyContent: "flex-end",
            },
            "& button": {
                fontSize: "12px",
            },
        },
        activeFilters: {
            listStyle: "none",
            padding: 0,
            margin: 0,
            marginTop: theme.spacing(1),
            "& > li": {
                display: "inline-block",
                marginRight: theme.spacing(1),
            },
        },
    };
});
const TypeOptions = ({ setFiltersOpen, category, categories, handleChangeCategory, disableFilters = false, filters, toggleFilterOption, }) => {
    const { addImage } = useRecentImages();
    const classes = useStyles();
    const onImageUploaded = (image) => {
        addImage({
            uuid: image.uuid,
            width: image.dimensions.width,
            height: image.dimensions.height,
        });
    };
    const { isUploading, totalProgress, retrying, bind } = useImageUpload(onImageUploaded);
    const fileRef = useRef(null);
    const handleAddButtonClick = () => {
        var _a;
        (_a = fileRef === null || fileRef === void 0 ? void 0 : fileRef.current) === null || _a === void 0 ? void 0 : _a.click();
    };
    const activeFilters = useMemo(() => {
        if (!filters) {
            return [];
        }
        const f = [];
        for (const filter of filters) {
            for (const option of filter.options) {
                if (option.checked) {
                    f.push({ filter, option });
                }
            }
        }
        return f;
    }, [filters]);
    return (React.createElement("div", { className: classes.typeOptions },
        categories && category && handleChangeCategory && (React.createElement(CardCategories, { handleChangeCategory: handleChangeCategory, category: category })),
        React.createElement(Container, null,
            React.createElement("div", { className: `${classes.filterButtonContainer} ${disableFilters ? "one-button" : ""}` },
                !disableFilters && (React.createElement(Button, { variant: "outlined", size: "small", onClick: () => setFiltersOpen && setFiltersOpen(true), startIcon: React.createElement(FilterIcon, null) },
                    React.createElement(Trans, null, "Filter selection"))),
                React.createElement(Button, { variant: "outlined", size: "small", onClick: handleAddButtonClick, startIcon: React.createElement(ImageIcon, null) },
                    React.createElement(Trans, null, "View with own pictures"),
                    React.createElement("input", Object.assign({ type: "file", ref: fileRef }, bind, { multiple: true, style: { position: "absolute", left: "-9000px" } })))),
            activeFilters.length > 0 && (React.createElement("ul", { className: classes.activeFilters }, activeFilters.map((filter) => {
                const label = filter.filter.title + ": " + filter.option.name;
                return (React.createElement("li", { key: label },
                    React.createElement(Chip, { label: label, size: "small", variant: "outlined", onDelete: () => toggleFilterOption && toggleFilterOption(filter.filter.type, filter.option.value) })));
            })))),
        isUploading && (React.createElement(UploadProgressDialog, { totalProgress: totalProgress, retrying: retrying }))));
};
export default TypeOptions;
